module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-01"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('ui-title-red', {
    attrs: {
      "textTitle": "Decisiones efectivas "
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Decisiones efectivas',
      "videoEmbed": "ADMINISTRACIONDINERO9DecisionesEfectivas  (ant40).mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInDown",
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('p', [_vm._v("\n        Para tomar decisiones\n        "), _c('strong', [_vm._v("efectivas")]), _vm._v(" hay que tener en cuenta que no es suficiente con ser\n        "), _c('strong', [_vm._v("eficiente")]), _vm._v(" o\n        "), _c('strong', [_vm._v("eficaz")]), _vm._v("."), _c('br'), _c('br'), _vm._v(" En el ejemplo de Juliana, veamos qué significa ahorrar el 10% de su sueldo de manera\n        "), _c('strong', [_vm._v("eficiente, eficaz o efectiva")]), _vm._v(":\n      ")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    staticClass: "animated fadeInLeft dura_1",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md5": "",
      "text-xs-center": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSize": 400,
      "imaSrc": "contenido/diapositiva_11",
      "imaAlt": "Cuatro flechas apuntando al centro"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_2",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md5": ""
    }
  }, [_c('ui-numlist', {
    staticClass: "animated fadeInRight dura_2 adorn-bottom adorn-top",
    attrs: {
      "bold": true,
      "bullet": "bullet-dav",
      "lista": _vm.lista
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5565713a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-10.vue
// module id = 980
// module chunks = 1